


















































import DefaultRevisionForm from "@/components/DefaultRevisionForm.vue";
import { createComponent } from "@vue/composition-api";
import { required } from "@/shared/validationRules";
import { formValidator } from "@/shared/formValidator";
import {
  ProductionRecipe,
  productionRecipeResource,
  produktResource,
  recepturaResource,
} from "@megarax/client/src/resources/plm";

const validationRules = {
  name: required,
  recipe: required,
  product: required,
  npType: required,
  npAmount: required,
  specificWeight: required,
};

export default createComponent({
  components: {
    DefaultRevisionForm,
  },
  props: {
    value: {
      type: ProductionRecipe,
      required: true,
    },
  },
  setup(props, ctx) {
    return {
      ...formValidator(),
      productionRecipeResource,
      produktResource,
      recepturaResource,
      validationRules,
    };
  },
});
